import { Link } from "react-router-dom";
import React, { useEffect } from "react";
import bg from "../assets/images/home/hero/1.webp";
import "../css/page-breadcrumbs.css";

// Removed TypeScript interface and type annotations for JavaScript compatibility
const PageBreadcrumbs = ({ breadcrumbs, subtitle, title }) => {
  useEffect(() => {
    console.log(breadcrumbs);
  }, [breadcrumbs]);
  return (
    <div className='page-breadcrumbs-container'>
      <img src={bg} alt='BG' className='page-breadcrumbs-bg' />
      <div className='page-breadcrumbs-overlay'></div>
      <div className='page-breadcrumbs-content'>
        {subtitle && (
          <span className='page-breadcrumbs-subtitle'>{subtitle}</span>
        )}
        <h1 className='page-breadcrumbs-title'>{title}</h1>
        <div className='page-breadcrumbs-links'>
          {breadcrumbs.items.map((item) => (
            <div key={item.name} className='page-breadcrumbs-link-item'>
              <Link to={item.href} style={{color:"white",textDecoration:"none"}}>{item.name}</Link>
              <span className='page-breadcrumbs-separator'>/</span>
            </div>
          ))}
          <span className='page-breadcrumbs-current'>
            {breadcrumbs.currentPage}
          </span>
        </div>
      </div>
    </div>
  );
};

export default PageBreadcrumbs;
